import React, {useState} from 'react'
import {Tooltip} from "@mui/material";
import ConfirmDialog from "../../../general/ConfirmDialog";
import EastIcon from "@mui/icons-material/East";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";


export default function HeimrechtTauschenComp({spieltagId, onRefresh}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [showDialog, setShowDialog] = useState(false)

    const change = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.league + "/liga/spiel/heimrecht/einzelspiel/change/" + spieltagId;
        FetchUtil.fetchPost(url,
            {},
            () => {
                setInfoMessage("Speichern erfolgreich");
                setShowDialog(false);
                onRefresh();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setShowDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setShowDialog(false);
            });
    }

    return <>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <Tooltip title="Heinrecht tauschen">
            <EastIcon style={{marginRight: 10, cursor: "pointer"}} onClick={() => setShowDialog(true)}/>
        </Tooltip>
        {showDialog && <ConfirmDialog header="Heimrecht tauschen"
                                       visible={true}
            callBackOnNein={() => setShowDialog(false)}
            callBackOnJa={() => change()}
                                       textOben={"Spielzeitpunkt wird nicht geändert, bitte kontrolliere ob dieser nach dem Tauschen richtig ist."}
                                       textUnten={"Möchtest du das Heimrecht an diesem Spieltag tauschen?"}
            />}
    </>
}